import styled from 'styled-components'
import { Flex, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { DeserializedPool } from 'state/types'
import BigNumber from 'bignumber.js'

const ApyLabelContainer = styled(Flex)`
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`

interface AprRowProps {
  pool: DeserializedPool
  discountRatePercent?: string
  discountSave: BigNumber
}

const AprRow: React.FC<AprRowProps> = ({ pool, discountRatePercent, discountSave }) => {
  const { t } = useTranslation()

  const { stakingToken } = pool

  return pool.promotionOn ? (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{t('Discount')}</Text>
        <Text bold>
          {Number(discountRatePercent)}
          {t('% OFF!')}
        </Text>
      </Flex>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{`${t('Price:')}`}</Text>
        <Text>
          {`${Number(pool.earningTokenPrice)
            .toFixed(3)
            .replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1')} `}
          {stakingToken.symbol}
          {` ($${new BigNumber(pool.earningTokenPrice.toString())
            .times(new BigNumber(pool.tokenPrice.toString()))
            .toFixed(2)})`}
        </Text>
      </Flex>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{`${t('Saving:')}`}</Text>
        <Text>{`$${discountSave.toFixed(2)}`}</Text>
      </Flex>
    </>
  ) : (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{`${t('Price:')}`}</Text>
        <Text>
          {`${Number(pool.earningTokenPrice)
            .toFixed(3)
            .replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1')} `}
          {stakingToken.symbol}
          {` ($${
            pool.tokenPrice
              ? new BigNumber(pool.earningTokenPrice.toString())
                  .times(new BigNumber(pool.tokenPrice.toString()))
                  .toFixed(2)
              : 0
          })`}
        </Text>
      </Flex>
    </>
  )
}

export default AprRow
